module.exports = __webpack_public_path__ + "09c9e5427141d845db620c7871e678f2.svg";